import { withType } from "../../../../utils/actionOperations";
import { HANDLE_CHANGE_BECHMARK_FILTERING, HANDLE_CHANGE_SAMPLE_COMMENTS_FILTER, REASSIGN_SAVED_DATA, RESET_ALL_STATE } from "../../../constants";

export const handleChangeBenchmarkFilter = (event) => {
    return dispatch => {
        dispatch(withType(HANDLE_CHANGE_BECHMARK_FILTERING, event));
    };
};

export const handleChangeSampleCommentsFilter = (event) => {
    return dispatch => {
        dispatch(withType(HANDLE_CHANGE_SAMPLE_COMMENTS_FILTER, event));
    };
};

export const resetState = (event) => {
    return dispatch => {
        dispatch(withType(RESET_ALL_STATE, event));
    };
};

export const resetFilterContentsFromSavedData = (event) => {
    return dispatch => {
        dispatch(withType(REASSIGN_SAVED_DATA, event));
    };
}

